import axios from 'axios'

// Set default axios
axios.defaults.baseURL = 'https://aurasjobs.onrender.com/'
// axios.defaults.baseURL = 'https://aurasjobs-node-backend.herokuapp.com/'
export default axios
